"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promiseTimeout = void 0;
function promiseTimeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
exports.promiseTimeout = promiseTimeout;
